import { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Admin from '../pages/admin';
import Chat from '../pages/chat/index';
import { Report } from '../pages/report';
import Shopping from '../pages/shopping';
import Marketing from '../pages/marketing';
import Tools from '../pages/tools';

import {
  Bot,
  Chat as ChatIcon,
  Company,
  Configs,
  Crm,
  Home,
  Pay,
  Report as ReportIcon,
  Ads,
} from '@poli-digital/react';

import { useGlotaTranslationContext } from '../contexts/GlotaTranslationContext';
import glotaTranslationService from '../services/glota-translation.service';

const Routers = () => {
  // @ts-ignore
  const wlConfig = useSelector((state) => state?.whitelabel?.config);
  const { currentLocale } = useGlotaTranslationContext();

  // Traduções dos itens do menu usando tradução síncrona local
  const homeText = glotaTranslationService.translateSync('spa.navigation.home', {}, currentLocale);
  const chatText = glotaTranslationService.translateSync('spa.navigation.chat', {}, currentLocale);
  const automationText = glotaTranslationService.translateSync('spa.navigation.automation', {}, currentLocale);
  const crmText = glotaTranslationService.translateSync('spa.navigation.crm', {}, currentLocale);
  const marketingText = glotaTranslationService.translateSync('spa.navigation.marketing', {}, currentLocale);
  const payText = glotaTranslationService.translateSync('spa.navigation.pay', {}, currentLocale);
  const reportText = glotaTranslationService.translateSync('spa.navigation.report', {}, currentLocale);
  const settingsText = glotaTranslationService.translateSync('spa.navigation.settings', {}, currentLocale);
  const administrationText = glotaTranslationService.translateSync('spa.navigation.administration', {}, currentLocale);

  const routesDefault: any = useMemo(() => [
    {
      path: '/',
      title: homeText,
      exact: true,
      sidebarName: homeText,
      icon: <Home />,
      content: '',
      showPwa: true,
      tag: 'home',
    },
    {
      path: '/chat',
      title: chatText,
      sidebarName: chatText,
      icon: <ChatIcon />,
      content: Chat,
      showPwa: true,
      tag: 'chat',
    },
    {
      path: '/automation',
      title: automationText,
      sidebarName: automationText,
      icon: <Bot />,
      content: '',
      tag: 'automation',
      showPwa: true,
    },
    {
      path: '/crm',
      title: crmText,
      exact: true,
      sidebarName: crmText,
      icon: <Crm />,
      content: '',
      showIsNew: true,
      tag: 'crm',
      isNew: true,
    },
    {
      path: '/marketing',
      title: marketingText,
      exact: true,
      sidebarName: marketingText,
      icon: <Ads />,
      content: Marketing,
      tag: 'marketing',
    },
    {
      path: '/shopping',
      title: payText,
      sidebarName: payText,
      subitens: true,
      icon: <Pay />,
      content: Shopping,
      showPwa: true,
      tag: 'pay',
    },
    {
      path: '/relatorio',
      title: reportText,
      sidebarName: reportText,
      subitens: true,
      icon: <ReportIcon />,
      content: Report,
      showPwa: true,
      tag: 'report',
    },
    {
      path: '/tools',
      title: settingsText,
      sidebarName: settingsText,
      subitens: true,
      icon: <Configs />,
      content: Tools,
      tag: 'tools',
    },
    {
      path: '/admin',
      title: administrationText,
      sidebarName: administrationText,
      subitens: true,
      icon: <Company />,
      content: Admin,
      showPwa: true,
      needAdmin: true,
      tag: 'admin',
    },
  ], [homeText, chatText, automationText, crmText, marketingText, payText, reportText, settingsText, administrationText, currentLocale]);

  const [routers, setRouters] = useState(routesDefault);

  useEffect(() => {
    if (wlConfig?.is_white_label) {
      const _routers: any = [];
      /**
       * Logica WhiteLabel
       */
      const navWl = Array.isArray(wlConfig?.buttons) ? wlConfig?.buttons : [];

      routesDefault.map((route: { tag: any; title: any; sidebarName: any }) => {
        const foundItemWL = navWl.find((e: any) => e.id === route.tag);
        if (foundItemWL) {
          // WhiteLabel pode sobrescrever traduções
          route.title = foundItemWL.name;
          route.sidebarName = foundItemWL.name;
          _routers.push(route);
        } else {
          // Se não encontrou no WhiteLabel, mantém traduções padrão
          _routers.push(route);
        }
      });

      /* end */
      setRouters(_routers);
    } else {
      // Se não é WhiteLabel, usa as rotas padrão com traduções
      setRouters(routesDefault);
    }
  }, [wlConfig, routesDefault]);

  return routers;
};

export { Routers };
